module.exports = __webpack_public_path__ + "img/carousel-3.1060bbb7.jpg";